export function toURLSearchParams(data: [string, any][]) {
  const params = new URLSearchParams();
  for (const [name, value] of data) {
    params.append(name, value);
  }
  return params;
}

export function getURLSearchParamsFromForm(form: HTMLFormElement) {
  const data = new FormData(form) as unknown as [string, any][];
  return toURLSearchParams(data);
}

export interface IFormFetchInit {
  action?: string;
  method?: string;
  body?: BodyInit | null | ((form: HTMLFormElement) => BodyInit | null);
  headers?: { [key: string]: string }[];
}

export async function formFetch(form: HTMLFormElement, init?: IFormFetchInit) {
  const body = init?.body instanceof Function ? (init.body as Function)(form) : init?.body;
  return await fetch(init?.action ?? form.action, {
    method: init?.method ?? form.method,
    body: body ?? getURLSearchParamsFromForm(form),
    headers: Object.assign(
      {
        "content-type": "application/x-www-form-urlencoded",
        accept: "application/json",
      },
      init?.headers ?? {},
    ),
  });
}

export async function formFetchJson(form: HTMLFormElement) {
  const response = await formFetch(form);
  return await response.json();
}

export async function formFetchHtml(form: HTMLFormElement) {
  const response = await formFetch(form);
  const text = await response.text();
  return new DOMParser().parseFromString(text, "text/html");
}
